<template>
    <ModalComponent
        :name="'editarEntradaPuertas-' + entrada.id"
        :title="'Configurar puertas'"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                    
            <div class="col-12">
                <div class="form-group">
                    <label for="descripcion">Título</label>
                    <multiselect
                        v-model="entrada.puertas"
                        placeholder="Puertas"
                        label="nombre"
                        track-by="id"
                        :options="puertas"
                        :multiple="true"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button">Guardar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['sesion_id', 'evento_id', 'entrada'],
        data() {
            return {
                puertas: [],
                loading: false,
            }
        },
        created() {
            this.getPuertas();
        },
        methods: {
            close(creado) {
                this.$emit('close', 'editarEntrada-' + this.entrada.id, creado);
            },
            getPuertas : function() {
                const params = {
                    filters : {},
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.puertas.index'), params).then(res => {
                    this.puertas = res.data.data;
                    this.loading = false;
                });
            },
            guardarPuertas() {
                this.loading = true;

                const data = {
                    puertas: this.entrada.puertas,                    
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    entrada_id: this.entrada.id
                };
                

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.puertas.update'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardarPuertas();
                }
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
